
const ABPopupMessageLayout = (customParams = {}) => {
    return {
        valueExpr: 'popupcode',
        displayExpr: 'popupcode',
        sort: [{ selector: "popupcode", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '3c5fb1b2-589b-4899-8bb5-aaae81f59e9f',
        selectboxlabel: 'Popup Message',
        params: {
            module: "ab",
            lookupType: "ABPopupMessages",
            showLookupGrid: true,
            ...customParams
        },
        columns:  [
            { dataField: "popupcode", caption: "Popup Code", dataType: "string" },
            { dataField: "description", caption: "Description", dataType: "string" },
            { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
            { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
            { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
            { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
            { dataField: "companyid", caption: "Company ID", dataType: "string", visible:false},
            { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
            { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
            { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
            { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
            { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
            { dataField: "recordnumber", caption: "Record #", dataType: "string", visible:false},
            
        ]
    };
}
const ABDbFieldsLookupLayout = 
     {
        valueExpr: 'id',
        displayExpr: 'name',
        sort: [{ selector: "name", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: false,
        gridKey: '28A406A7-2C12-44AD-9500-D4B1E55730A9',
        params: {
            module: "ab",
            lookupType: "ABDBFields",
            showLookupGrid: false,
        },
        columns:  [
            { dataField: "name", caption: "Default Alias", dataType: "string" },
            
        ]
    }
    const ABDbLayoutLookupLayout = (customParams = {}) => {
    return {
        valueExpr: 'id',
        displayExpr: 'name',
        sort: [{ selector: "name", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: false,
        gridKey: '28A406A7-2C12-44AD-9500-D4B1E55730A9',
        params: {
            module: "ab",
            lookupType: "ABLayout",
            showLookupGrid: true,
            layoutId:customParams.layoutId
        },
        columns:  [
            { dataField: "name", caption: "Layout Name", dataType: "string" },
            { dataField: "delimeter", caption: "Delimiter", dataType: "string" },
            { dataField: "recorddelimited", caption: "Record Delimited", dataType: "string" },
            { dataField: "firstlinereserved", caption: "1st Line Reserved", dataType: "string" },
            { dataField: "defaultflag", caption: "Default Flag", dataType: "string" },
            
        ]
    };
}
export {
    ABPopupMessageLayout,
    ABDbFieldsLookupLayout,
    ABDbLayoutLookupLayout
}